import { render, staticRenderFns } from "./MiniStackedBars.vue?vue&type=template&id=363af127&scoped=true"
import script from "./MiniStackedBars.vue?vue&type=script&lang=js"
export * from "./MiniStackedBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363af127",
  null
  
)

export default component.exports